import firebase from '@/firebase';

const PATH = '/estimation';

const getUserId = () => firebase.auth().currentUser.uid;
const getUserReference = () => firebase
  .firestore()
  .collection('users')
  .doc(getUserId());

export default client => ({
  create: formValues => client.post(PATH, formValues).then(res => res.data.data.result),

  save(estimate) {
    return getUserReference()
      .collection('estimates')
      .add({
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        ...estimate,
      });
  },

  edit(estimateId, updatedEstimate) {
    return getUserReference()
      .collection('estimates')
      .doc(estimateId)
      .set({
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        ...updatedEstimate,
      });
  },

  getAll() {
    return getUserReference()
      .collection('estimates')
      .get()
      .then((estimatesSnapshot) => {
        // we want to have the same keys order
        const estimates = new Map();
        estimatesSnapshot.forEach((doc) => {
          estimates[doc.id] = doc.data();
        });
        return estimates;
      });
  },

  get(id) {
    return getUserReference()
      .collection('estimates')
      .doc(id)
      .get()
      .then(doc => doc.data());
  },

  delete(estimateId) {
    return getUserReference()
      .collection('estimates')
      .doc(estimateId)
      .delete();
  },

  updateSettings({ path, value }) {
    return getUserReference().update({ [`settings.${path}`]: value });
  },

  getSettings() {
    return getUserReference().get().then(userDocument => userDocument.data().settings);
  },

  getSettingsForEstimate(estimateId) {
    return getUserReference()
      .collection('settingsHistory')
      .doc(estimateId)
      .get()
      .then(doc => doc.data());
  },
});
